import 'govuk-frontend/dist/govuk/govuk-frontend.min.css'
import { CSSProperties, ReactNode } from 'react'
import { GOVUK_COLOURS } from './colours'

interface GovUKContentBoxProps {
  children: ReactNode
  padding?: 'default' | 'large'
  className?: string
  style?: CSSProperties
}

const boxStyle = (padding: 'default' | 'large'): CSSProperties => ({
  border: `1px solid ${GOVUK_COLOURS.midGrey}`,
  padding: padding === 'large' ? '40px' : '20px',
  backgroundColor: GOVUK_COLOURS.lightGrey,
})

export function GovUKContentBox({
  children,
  padding = 'default',
  className,
  style,
}: GovUKContentBoxProps) {
  return (
    <div className={className} style={{ ...boxStyle(padding), ...style }}>
      {children}
    </div>
  )
}
